import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { trackEvent, EVENTS } from '../utils/analytics';
import '../styles/Header.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { token, logout } = useContext(AuthContext);

  const toggleMenu = () => {
    // Track when users open/close mobile menu
    trackEvent(EVENTS.MENU_TOGGLE, {
      action: !isOpen ? 'open' : 'close',
      screenWidth: window.innerWidth
    });
    setIsOpen(!isOpen);
  };

  const handleNavigation = (destination, isMobile = false) => {
    // Track navigation events
    trackEvent(isMobile ? EVENTS.MOBILE_NAVIGATION : EVENTS.NAVIGATION, {
      destination,
      from: window.location.pathname
    });
    if (isMobile) {
      closeMenu();
    }
  };

  const handleLogout = (isMobile = false) => {
    trackEvent(EVENTS.LOGOUT, {
      device: isMobile ? 'mobile' : 'desktop',
      from: window.location.pathname
    });
    logout();
    if (isMobile) {
      closeMenu();
    }
  };

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="header">
      <div className="container header-container">
        <div className="header-content">
          {/* Logo */}
          <Link 
            to="/" 
            className="header-logo" 
            onClick={() => handleNavigation('home')}
          >
            <i className="fas fa-chart-line"></i>
            <span>DynaStoxx</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="header-nav">
            <Link 
              to="/search" 
              className="nav-link"
              onClick={() => handleNavigation('search')}
            >
              <i className="fas fa-search"></i>
              <span>Suche</span>
            </Link>
            <Link 
              to="/portfolio" 
              className="nav-link"
              onClick={() => handleNavigation('portfolio')}
            >
              <i className="fas fa-chart-bar"></i>
              <span>Portfolio</span>
            </Link>
            <Link 
              to="/articles" 
              className="nav-link"
              onClick={() => handleNavigation('articles')}
            >
              <i className="fas fa-newspaper"></i>
              <span>Analysen</span>
            </Link>
            <Link 
              to="/value-investing" 
              className="nav-link"
              onClick={() => handleNavigation('value-investing')}
            >
              <i className="fas fa-book"></i>
              <span>Value Investing</span>
            </Link>
          </nav>

          {/* Desktop Auth Controls */}
          <div className="header-auth">
            {token ? (
              <button 
                onClick={() => handleLogout(false)} 
                className="secondary-button"
              >
                <i className="fas fa-sign-out-alt"></i>
                <span>Abmelden</span>
              </button>
            ) : (
              <div className="auth-buttons">
                <Link 
                  to="/login" 
                  className="secondary-button"
                  onClick={() => handleNavigation('login')}
                >
                  Anmelden
                </Link>
                <Link 
                  to="/register" 
                  className="primary-button"
                  onClick={() => handleNavigation('register')}
                >
                  Registrieren
                </Link>
              </div>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="mobile-menu-button"
          >
            <i className={`fas ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="mobile-menu">
            <Link 
              to="/search" 
              className="mobile-menu-item" 
              onClick={() => handleNavigation('search', true)}
            >
              <i className="fas fa-search"></i>
              <span>Suche</span>
            </Link>
            <Link 
              to="/portfolio" 
              className="mobile-menu-item" 
              onClick={() => handleNavigation('portfolio', true)}
            >
              <i className="fas fa-chart-bar"></i>
              <span>Portfolio</span>
            </Link>
            <Link 
              to="/articles" 
              className="mobile-menu-item" 
              onClick={() => handleNavigation('articles', true)}
            >
              <i className="fas fa-newspaper"></i>
              <span>Analysen</span>
            </Link>
            <Link 
              to="/value-investing" 
              className="mobile-menu-item" 
              onClick={() => handleNavigation('value-investing', true)}
            >
              <i className="fas fa-book"></i>
              <span>Value Investing</span>
            </Link>
            {token ? (
              <button 
                onClick={() => handleLogout(true)} 
                className="mobile-menu-item"
              >
                <i className="fas fa-sign-out-alt"></i>
                <span>Abmelden</span>
              </button>
            ) : (
              <>
                <Link 
                  to="/login" 
                  className="mobile-menu-item" 
                  onClick={() => handleNavigation('login', true)}
                >
                  Anmelden
                </Link>
                <Link 
                  to="/register" 
                  className="mobile-menu-item highlight" 
                  onClick={() => handleNavigation('register', true)}
                >
                  Registrieren
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;